/*
 * SS06445 - the MCP consent page ("Authorize access") posted the stored access token to the MCP server
 * without looking at it. An expired one made the MCP connection mint answer 401, and the connector said
 * "try again", which fails the same way. These read when the stored sign-in expires, so the page can
 * renew it first.
 */

/** A JWT's `exp` in ms, or null when the token is not a readable JWT. */
function jwtExpiresAt(token) {
  const parts = typeof token === "string" ? token.split(".") : [];
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "=")));
    return typeof claims.exp === "number" ? claims.exp * 1000 : null;
  } catch (err) {
    return null;
  }
}

/** When the stored sign-in's access token expires (ms): its JWT `exp`, else the token answer's ".expires";
 *  null when neither is readable. */
export function accessTokenExpiresAt(authorizationData) {
  if (!authorizationData) return null;
  const fromJwt = jwtExpiresAt(authorizationData.access_token);
  if (fromJwt !== null) return fromJwt;
  const expires = Date.parse(authorizationData[".expires"]);
  return isNaN(expires) ? null : expires;
}

/** Whether the stored access token is expired or expires within `marginMs`. An unknown expiry counts as
 *  fresh, which is how the page behaved before. */
export function accessTokenExpiring(authorizationData, now = Date.now(), marginMs = 60000) {
  const expiresAt = accessTokenExpiresAt(authorizationData);
  return expiresAt !== null && expiresAt - now <= marginMs;
}
